// export const backUrl = 'http://10.1.0.40:8800';
export const backUrl = 'https://api-sso.jiulong-aiot.com';